import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import AIsuggestions from "../components/Dashboard/AIsuggestions";
import { FilterButton, Loader, TabButtonGroup } from "../components/shared";
import { emailFilterTabs, buttonLabels } from "../utils/data";
import { useChatPageData, useAgentData } from "../utils/hooks";
import useMediaQuery from "../utils/hooks/useMediaQuery";
import { useOutletContext } from "react-router-dom";
import { db } from "../utils/firebase/firebaseConfig";

const EmailInbox = () => {
  const { loading: summaryLoading } = useAgentData();
  const { loading: chatLoading } = useChatPageData();
  const [checkedItems, setCheckedItems] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [emailList, setEmailList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(3);

  const isMdUp = useMediaQuery("(min-width: 768px)");
  const { toggleSidebar } = useOutletContext();

  const filteredEmails = emailList.filter((item) => {
    const query = searchQuery.toLowerCase();
    return (
      item.subject?.toLowerCase().includes(query) ||
      item.sender?.toLowerCase().includes(query) ||
      item.message?.toLowerCase().includes(query)
    );
  });

  useEffect(() => {
    const fetchEmails = async () => {
      const querySnapshot = await getDocs(collection(db, "emails"));
      const emails = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEmailList(emails);
    };
    fetchEmails();
  }, []);

  const toggleCheckbox = (index) => {
    setCheckedItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  if (summaryLoading || chatLoading) {
    return (
      <div className="w-full h-[calc(100vh-100px)] flex items-center justify-center">
        <Loader size={40} color="black" />
      </div>
    );
  }

  return (
    <div className="flex flex-col md:flex-row w-full h-full min-h-[calc(100vh-100px)] overflow-x-hidden">
      {" "}
      <div className="flex flex-col flex-1 min-h-0 gap-2 px-2 lg:gap-2">
        <div className="w-full h-auto border-b border-[#0000002B] flex justify-between items-center pb-2">
          <h1 className="text-[13px] font-semibold leading-[100%] text-black font-inter">
            Email Inbox
          </h1>
          <div className="flex flex-row items-center gap-2 md:hidden">
            <button
              onClick={toggleSidebar}
              className="px-3 py-1 text-[10px] font-medium text-black border border-[#0000002B] rounded-md hover:bg-black-700 transition"
            >
              Menu
            </button>
          </div>
        </div>

        <TabButtonGroup
          buttonLabels={buttonLabels}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
        />

        <div className="flex flex-col w-full gap-2 pb-1 mt-2 md:flex-row md:pr-2 ">
          <div className="w-full pr-0 md:w-1/4 md:pr-2">
            <div className="w-full shadow-[4px_4px_20px_0px_#00000040] h-[70px] rounded-[12px] justify-between px-2 py-3 flex flex-col">
              <div className="flex flex-row items-start justify-between">
                <span className="text-[11px] font-medium font-inter leading-[100%] tracking-[-0.03em] text-black">
                  Pending Email
                </span>
              </div>
              <div className="flex items-center gap-1 mt-2">
                <span className="text-[20px] font-bold font-inter leading-[100%] text-black">
                  24
                </span>
                <img
                  src="/icons/red-arrowDown.png"
                  alt="trend icon"
                  className="w-[18px] h-[18px]"
                />
                <span className="w-[30px] text-[#FF1F1F] pt-1 h-[17px] text-[10px] text-center font-normal font-inter leading-[100%] rounded">
                  3%
                </span>
                <span className="font-inter font-normal text-black text-opacity-60 text-[9px] leading-[100%]">
                  from yesterday
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-col w-full">
            <div className="flex flex-row items-center justify-between w-full">
              <div className="w-full h-[35px] rounded-[12px] bg-white shadow-[4px_4px_20px_0px_#00000040] flex items-center pl-4 justify-between">
                <input
                  type="text"
                  placeholder="Search Customers .."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full bg-transparent text-[12px] font-inter font-normal text-[#00000096] placeholder:text-[11px] placeholder:text-[#00000096] outline-none text-opacity-40"
                />

                <FilterButton onClick={() => console.log("Filter clicked")} />
              </div>
            </div>

            <div className="flex flex-row flex-wrap gap-2 pb-2 mt-2">
              {emailFilterTabs.map((item, index) => (
                <div
                  key={index}
                  className={`w-fit h-[25px] px-2 rounded-[8px] flex items-center gap-2 cursor-pointer ${
                    item.highlight
                      ? "bg-white shadow-[4px_4px_20px_0px_#00000040]"
                      : ""
                  }`}
                >
                  <img
                    src={item.icon}
                    alt={item.label}
                    className="w-[16px] h-[16px] object-contain"
                  />
                  <span className="text-[11px] font-inter font-normal text-black leading-[100%]">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className="pr-2 overflow-y-auto"
          style={{ maxHeight: "calc(100vh - 360px)" }}
        >
          <div className="flex flex-col gap-4">
            {filteredEmails.map((item) => (
              <div
                key={item.id}
                className="flex flex-row items-start w-full gap-1 px-3"
              >
                <input
                  type="checkbox"
                  checked={checkedItems.includes(item.id)}
                  onChange={() => toggleCheckbox(item.id)}
                  className="w-[15px] h-[15px] accent-black mt-[2px]"
                />
                <div className="flex flex-col w-full pl-2">
                  <div className="flex items-center justify-between w-full">
                    <span className="text-[11px] font-semibold font-inter leading-[100%] text-black">
                      {item.subject}
                    </span>
                  </div>
                  <span className="text-[11px] py-2 font-semibold font-inter leading-[100%] text-black">
                    {item.sender}
                  </span>
                  <div className="text-[11px] font-inter text-[#00000073] text-opacity-80">
                    {item.message}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-t-[12px]   h-[180px] flex flex-col shadow-[4px_4px_20px_0px_#00000040] w-full overflow-hidden">
          <div className="flex flex-col px-4 pt-2">
            <input
              type="text"
              placeholder="To"
              className="text-[11px] border-b border-[#0000002B] py-2 pb-1 font-inter text-[#00000073] text-opacity-80 outline-none placeholder:text-[#00000073] placeholder:text-opacity-80"
            />
            <input
              type="text"
              placeholder="Subject"
              className="text-[11px] border-b border-[#0000002B] py-2 pb-2 font-inter text-[#00000073] text-opacity-80 outline-none placeholder:text-[#00000073] placeholder:text-opacity-80"
            />
          </div>

          <div className="flex flex-col justify-between flex-1">
            <textarea
              placeholder=""
              className="flex-1 resize-none px-4 py-2 text-[11px] font-inter text-[#000000] text-opacity-80 outline-none placeholder:text-[#00000073] placeholder:text-opacity-80"
            />

            <div className="flex flex-row items-center justify-end px-4 py-1 pb-2 gap-x-3">
              <img
                src="/icons/attach.png"
                alt="Attach"
                className="w-[18px] h-[18px] rounded-full object-cover cursor-pointer"
              />
              <img
                src="/icons/grey-call.png"
                alt="Call"
                className="w-[18px] h-[18px] rounded-full object-cover cursor-pointer"
              />
              <button className="px-3 w-auto h-6 text-opacity-90 text-white text-[9px] font-inter font-normal leading-[100%] tracking-[0%] bg-black rounded-[8px] flex items-center justify-center">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
      {isMdUp && (
        <div className="border-[#0000002B] w-[21%] border-l h-full">
          <AIsuggestions />
        </div>
      )}
    </div>
  );
};

export default EmailInbox;
